<div class="user-session-info-content">
    @if (isPersonalAppMode$ | async) {
        @if (isAuthenticated$ | async) {
            <div data-test="user-session-info-form">
                <priva-form-group [hasHelp]="true" [hasLabel]="true">
                    <ng-container data-label>{{ 'GENERAL.TITLE.ACTIVE_USER' | translate }}</ng-container>
                    <ng-container data-help>
                        <div class="name-logout-wrapper">
                            <div class="user-name-label">
                                {{ userName$ | async }}
                            </div>
                            <button
                                priva-button
                                (click)="logout()"
                                importance="Tertiary"
                                class="log-out-button"
                                data-test="logout-btn"
                            >
                                {{ 'GENERAL.TITLE.LOGOUT' | translate }}
                            </button>
                        </div>
                    </ng-container>
                </priva-form-group>
                <priva-form-group [hasHelp]="true" [hasLabel]="true">
                    <ng-container data-label>{{ 'GENERAL.TITLE.LOGIN_TIME' | translate }}</ng-container>
                    <ng-container data-help>{{ loginTime$ | async }}</ng-container>
                </priva-form-group>
            </div>
        } @else {
            <priva-notification status="Warning">{{
                'ERROR.TITLE.LOGIN_TO_PROCEED_WITH_ACTIVITIES' | translate
            }}</priva-notification>
            <button
                priva-button
                importance="primary"
                (click)="login()"
                data-test="user-session-sign-in-btn"
                class="start-session-button"
            >
                {{ 'LOGIN.TITLE.DEFAULT' | translate }}
            </button>
        }
    } @else {
        <div data-test="no-user-session-label">
            {{ 'ERROR.TITLE.NO_USER_INFORMATION_AVAILABLE' | translate }}
        </div>
    }
</div>
